module.exports = __webpack_public_path__ + "img/Dan-Newhart.4af767d1.png";